import * as CryptoJS from 'crypto-js';
import { ENCRYPT_DECRYPT_KEY } from '../constants/commonConstants';

/**
 * Encrypts the data using the AES algorithm.
 *
 * This function takes the input data and encrypts it using the AES algorithm with the specified encryption key.
 *
 * @param {string} data - The data to be encrypted.
 * @return {string} - The encrypted data.
 */
export const encryptData = (data) => {
	return CryptoJS.AES.encrypt(data, ENCRYPT_DECRYPT_KEY).toString();
};

/**
 * Decrypts the data using the AES algorithm.
 *
 * This function takes the encrypted data and decrypts it using the AES algorithm with the specified encryption key.
 *
 * @param {string} data - The encrypted data to be decrypted.
 * @return {string} - The decrypted data.
 */

export const decryptData = (data) => {
	if (!data || typeof data !== 'string') return data;

	if (data !== null && data?.startsWith('U2FsdGVkX')) {
		const decrypted = CryptoJS.AES.decrypt(data, ENCRYPT_DECRYPT_KEY);
		const result = decrypted.toString(CryptoJS.enc.Utf8);
		return result || null;
	} else {
		return data;
	}
};


  // Function to decrypt an encrypted value and convert back to boolean
  export const decryptBoolean = (data) => {
    if (data !== null && data?.startsWith('U2FsdGVkX')) {
      const decrypted = CryptoJS.AES.decrypt(data, ENCRYPT_DECRYPT_KEY);
      const decryptedText = decrypted.toString(CryptoJS.enc.Utf8);
      return decryptedText === "true"; // Convert the string back to boolean
    } else {
      return data
    }
  }